// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"252ac053","257":"830063f4","258":"4ddc949c","372":"8f75d880","597":"63728ace","627":"fe4b080a","929":"b079d861"}[chunkId] + ".chunk.js";
};